import script from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextMenu.vue?vue&type=script&setup=true&lang=js"

import "./ContextMenu.vue?vue&type=style&index=0&id=8ee40f9e&lang=scss&scoped=true"

import exportComponent from "/Users/lgd_sunday/Desktop/langChain/wwzhidao-admin/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ee40f9e"]])

export default __exports__